import BaseRepository from "./BaseRepository";
import QuoteDetailAPICall from "../service/QuoteDetailAPICall";
import Common from "src/pages/Quote/Common";
import { __remove, __set } from "src/store/axios_indicator";
import QuoteRepository from "./OpenQuoteRepository";
import ProductPricingAPICall from "src/service/ProductPricingAPICall";
import Constants from "src/support/Constants";
import Helper from "src/support/Helper";

class QuoteDetailRepository extends BaseRepository {
    getHeaderDetail = async (quoteNumber, quoteProvisionalNumber) => {
        return await new QuoteDetailAPICall().getHeaderDetail(quoteNumber, quoteProvisionalNumber);
    };
    getLineItemsDetail = async (params) => {
        return await new QuoteDetailAPICall().getLineItemsDetail(params);
    };

    setSelectAllQty = (quoteOrgList, qtList, quoteCurentStatus) => {
        let selectedQty = "";

        if (qtList && Object.entries(qtList).length > 0 && quoteOrgList && Object.entries(quoteOrgList).length > 0) {
            const totalCountQty1 = Object.entries(quoteOrgList).filter(v => v[1].quantity_quantity_1 > 0 && v[1]?.product?.ERPPartNumber).length;
            const selectedQty1 = Object.entries(qtList).filter(v => v[1].quantity_field_selected === "quantity_1" && v[1].status === quoteCurentStatus && v[1]?.product?.ERPPartNumber).length;
            if (selectedQty1 > 0 && totalCountQty1 === selectedQty1) {
                selectedQty = "quantity_1"
            }
            else {
                // check for Qty 2
                const totalCountQty2 = Object.entries(quoteOrgList).filter(v => v[1].quantity_quantity_2 > 0 && v[1]?.product?.ERPPartNumber).length;
                const selectedQty2 = Object.entries(qtList).filter(v => v[1].quantity_field_selected === "quantity_2" && v[1].status === quoteCurentStatus && v[1]?.product?.ERPPartNumber).length;
                if (selectedQty2 > 0 && totalCountQty2 === selectedQty2) {
                    selectedQty = "quantity_2"
                } else {
                    const totalCountQty3 = Object.entries(quoteOrgList).filter(v => v[1].quantity_quantity_3 > 0 && v[1]?.product?.ERPPartNumber).length;
                    const selectedQty3 = Object.entries(qtList).filter(v => v[1].quantity_field_selected === "quantity_3" && v[1].status === quoteCurentStatus && v[1]?.product?.ERPPartNumber).length;

                    if (selectedQty3 > 0 && totalCountQty3 === selectedQty3) {
                        selectedQty = "quantity_3"
                    }
                }
            }

        }
        return selectedQty;
    }
    // As per the SAP API object update - set target currency.
    setQuoteBulk = async (quoteList) => {
        let selectedQuote = [];
        let priceProductList = [];

        __set('QUOTE_API_CALL');
        for (let i = 0; i < Object.entries(quoteList).length; i++) {
            let ele = Object.entries(quoteList)[i];
            let _quote = {
                partNumber: ele[1].product?.ERPPartNumberModified ? '' : ele[1].partNumber,
                manufacturerPartNumber: ele[1].product.ManufacturerPartNumber,
                manufacturerCode: ele[1].product?.ManufacturerCode,
                manufacturerName: ele[1].product.ManufacturerName,
                customerPartNumber: ele[1].customerPartNumber,
                itemNumber: ele[1].product.ItemNumber,
                quantity1: ele[1][`quantity_${ele[1].quantity_field_selected}`],
                targetCurrency: ele[1]?.targetCurrency ? ele[1].targetCurrency : (ele[1].quoteStatus === "No Bid" ? window.mct : ele[1].quoteCurrency),
                targetUnitPrice: ele[1]?.targetPrice,
                endCustomer: "",
                competition: "",
                comments: "",
                ERPMFRPartNumber: ele[1].product.ERPMFRPartNumber,
                erpManufacturerPartNumber: ele[1].product.ERPMFRPartNumber,
                min: ele[1].product.Min,
                mult: ele[1].product.Mult,
                erpManufacturerName: ele[1].product?.ERPManufacturerName,
                erpManufacturerCode: ele[1].product?.ERPManufacturerCode,
            }
            selectedQuote.push(_quote);

            priceProductList.push({
                partNumber: _quote.partNumber,
                erpManufacturerCode: _quote.manufacturerCode,
                erpMfrPartNumber: _quote.erpManufacturerPartNumber,
                customerPartNumber: _quote.customerPartNumber,
                currency: "EUR"
            })
        }
        selectedQuote = await new QuoteDetailRepository().getEuroMinPrice(priceProductList, selectedQuote);
        __remove('QUOTE_API_CALL');
        return selectedQuote;
    }


    setBulkQuoteBOM = async (quoteList) => {
        let selectedQuote = [];
        let priceProductList = [];
        __set('QUOTE_API_CALL');

        for (let i = 0; i < Object.entries(quoteList).length; i++) {
            let ele = Object.entries(quoteList)[i];

            if (ele[1].isDeleted !== undefined && ele[1].isDeleted !== null && ele[1].isDeleted === false) {
                /**
                 * if customer partnumber is empty then select first from the list if cpn list available
                 */
                // let customerPartNumber = ele[1].customerPartNumber ? ele[1].customerPartNumber :
                //     (ele[1].product && ele[1].product.CustomerPartNumbers && isArray(ele[1].product.CustomerPartNumbers) && ele[1].product.?.CustomerPartNumbers?.ength > 0) ? ele[1].product.CustomerPartNumbers[0].CPN :
                //         ele[1].customerPartNumber
                // 14810 - DT - 18/10/2023
                let customerPartNumber = ele[1].cpnTypeName === Constants.cpnTypes.MANUALCPN ? ele[1].manualCPN : ele[1].customerPartNumber;
                let _quote = {
                    partNumber: ele[1].product.ERPPartNumberModified ? '' : ele[1].ERPPartNumber,
                    manufacturerPartNumber: ele[1].product.ManufacturerPartNumber,
                    manufacturerCode: ele[1].product.ManufacturerCode,
                    manufacturerName: ele[1].product.ManufacturerName,
                    customerPartNumber: customerPartNumber,
                    itemNumber: ele[1].product.ItemNumber,
                    quantity1: ele[1].quantity,
                    targetCurrency: window.mct,
                    targetUnitPrice: null,
                    endCustomer: "",
                    competition: "",
                    comments: "",
                    ERPMFRPartNumber: ele[1].product.ERPMFRPartNumber,
                    erpManufacturerPartNumber: ele[1].product.ERPMFRPartNumber,
                    min: ele[1].product.Min,
                    mult: ele[1].product.Mult,
                    erpManufacturerName: ele[1].product?.ERPManufacturerName,
                    erpManufacturerCode: ele[1].product?.ERPManufacturerCode,
                };
                selectedQuote.push(_quote);

                priceProductList.push({
                    partNumber: _quote.partNumber,
                    erpManufacturerCode: _quote.manufacturerCode,
                    erpMfrPartNumber: _quote.erpManufacturerPartNumber,
                    customerPartNumber: customerPartNumber,
                    currency: "EUR"
                })
            }
        }

        selectedQuote = await new QuoteDetailRepository().getEuroMinPrice(priceProductList, selectedQuote);
        __remove('QUOTE_API_CALL');
        return selectedQuote;
    }

    getEuroMinPrice = async (list, selectedQuote) => {
        const minPriceRes = await new QuoteRepository().getQuoteMinPriceBySpeedBoat();
        const speedBoatVal = parseInt(minPriceRes[1]);
        let pricing = await new ProductPricingAPICall().getPricingNew(list, false, false);
        if (selectedQuote?.length > 0) {
            selectedQuote.map((v, i) => {
                let _priceKey = `${v.erpManufacturerPartNumber}-${v.partNumber}`
                _priceKey = v.customerPartNumber ? `${_priceKey}-${v.customerPartNumber}` : _priceKey;
                const lowestPrice = new ProductPricingAPICall().getLowestMarketPrice(pricing[_priceKey]?.prices);
                v.quantity1 = Common.validateQuantityRFQNew(v.min, v.mult, speedBoatVal, lowestPrice, v.quantity1);
                delete v.min
                delete v.mult
            });
        }

        return selectedQuote;
    };

    getSubmittedQuoteExportUrl = async (params = {}) => {
        return await new QuoteDetailAPICall().getSubmittedQuoteExportUrl(params);
    };

    // DT - 8976 - Update unitPrice = QuotedPrice
    /**  10051 : Add scaleRef value in quoteLineNumber : Pankaj : 21 April 2023     */
    setAddToCartQuote = async (quoteList) => {
        let cartQuoteList = [];
        Object.entries(quoteList).map((ele, idx) => {
            let _quote = {
                partNumber: ele[1].partNumber,
                itemNumber: ele[1].product.ItemNumber,
                manufacturerPartNumber: (ele[1].mfrPartNumber && ele[1].mfrPartNumber.trim()) ? ele[1].mfrPartNumber : ele[1].product.ManufacturerPartNumber,
                quantity: ele[1][`quantity_${ele[1].quantity_field_selected}`],
                unitPrice: ele[1][`quotedPrice_${ele[1].quantity_field_selected}`],
                subtotal: ele[1][`subTotal_${ele[1].quantity_field_selected}`],
                backOrderedQuantity: 0,
                manufacturerCode: ele[1].product?.ManufacturerCode,
                manufacturerName: ele[1].product.ManufacturerName,
                currency: ele[1][`currency_${ele[1].quantity_field_selected}`],
                cpn: ele[1].customerPartNumber,
                assetURL: "",
                quoteLineNumber: ele[1][`scaleRef_${ele[1].quantity_field_selected}`], // confirm this line for scaleRef
                erpMfrPartNumber: ele[1].product.ERPMFRPartNumber,
                quoteScheduleDetails: ele[1].scheduleDetails,
                erpManufacturerName: ele[1].product?.ERPManufacturerName,
                erpManufacturerCode: ele[1].product?.ERPManufacturerCode,
            }
            cartQuoteList.push(_quote)
        });

        const cartParams = {
            currency: cartQuoteList[0].currency,
            type: "Quote",
            cartItems: cartQuoteList
        };
        return cartParams;
    }

    setQuoteOrderCheckoutList = (quoteList) => { // 15033_main_orig
        let productList = {};
        let inventoryList = {};

        Object.entries(quoteList).map((ele, idx) => {
            const detail = ele[1].product;

            let _product = {
                ROHSCompliantCodeValue: detail.ROHSCompliantCodeValue,
                ROHSCompliantCode: detail.ROHSCompliantCode,
                NCNRFlag: detail.NCNRFlag,
                PackagingTypeCode: detail.PackagingTypeCode,
                WebOnlyFlag: detail.WebOnlyFlag,
                NPIFlag: detail.NPIFlag,
                ObsoleteFlag: detail.ObsoleteFlag,
                TopSellerFlag: detail.TopSellerFlag,
                EndOfLifeFlag: detail.EndOfLifeFlag,
                ERPPartNumber: detail.ERPPartNumber,
                ERPPartNumberModified: detail.ERPPartNumberModified,
                ItemNumber: detail.ItemNumber,
            }
            productList[detail.ItemNumber] = _product;
            productList[detail.ERPPartNumber] = _product;
            inventoryList[detail.ERPPartNumber] = detail.assets.inventory
        });

        localStorage.setItem("cartProductData", JSON.stringify(productList))
        localStorage.setItem("cartProductInventoryData", JSON.stringify(inventoryList))
    }

    getApprovedQuoteList = async(params) => {
        return await new QuoteDetailAPICall().getApprovedQuotesList(params)
    }

    setBulkQuoteBOMForCrossReference = async (list) => {
        let selectedQuote = [];
        let priceProductList = [];
        __set('QUOTE_API_CALL');
        for (let i = 0; i < Object.entries(list).length; i++) {
            let ele = Object.entries(list)[i];
            let _quote = {
                partNumber: ele[1]?.Product?.erpPartNumber,
                manufacturerPartNumber: ele[1]?.Product.manufacturerPartNumber,
                manufacturerCode: ele[1]?.Product?.manufacturerCode,
                manufacturerName: ele[1]?.Product?.manufacturerName,
                customerPartNumber: Helper.valueIsNotNull(ele[1]?.Product?.customerPartNumbers) ? ele[1]?.Product?.customerPartNumbers : "",
                itemNumber: ele[1]?.Product?.itemNumber,
                quantity1: 0,
                targetCurrency: window.mct,
                targetUnitPrice: null,
                endCustomer: "",
                competition: "",
                comments: "",
                ERPMFRPartNumber: ele[1]?.Product.manufacturerPartNumber,
                erpManufacturerPartNumber: ele[1]?.Product.manufacturerPartNumber,
                min: ele[1]?.Product?.qtyMin,
                mult: ele[1]?.Product?.qtyMult,
                erpManufacturerName: ele[1]?.Product?.erpManufacturerName,
                erpManufacturerCode: ele[1]?.Product?.erpManufacturerCode,
            };
            selectedQuote.push(_quote);

            priceProductList.push({
                partNumber: ele[1].Product?.erpPartNumber,
                erpManufacturerCode: ele[1].Product?.erpManufacturerCode,
                erpMfrPartNumber: ele[1]?.Product.manufacturerPartNumber,
                customerPartNumber: Helper.valueIsNotNull(ele[1]?.Product?.customerPartNumbers) ? ele[1]?.Product?.customerPartNumbers : "",
                currency: "EUR"
            })
        }
        selectedQuote = await new QuoteDetailRepository().getEuroMinPrice(priceProductList, selectedQuote);
        __remove('QUOTE_API_CALL');
        return selectedQuote;
    }

}

export default QuoteDetailRepository;